export * from './child';
export * from './collapse.form.wrapper.component';

import {CollapseFormWrapperComponent} from './collapse.form.wrapper.component';
import {CollapseFormChildComponent, CollapseFormHeaderComponent} from './child';

export const COLLAPSE_COMPONENTS = [
    CollapseFormWrapperComponent,
    CollapseFormChildComponent,
    CollapseFormHeaderComponent
];

export const COLLAPSE_PROVIDERS = [];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/collapse/index.ts